import { render, staticRenderFns } from "./VideoStrapi.vue?vue&type=template&id=6774d4bb&scoped=true&"
import script from "./VideoStrapi.vue?vue&type=script&lang=js&"
export * from "./VideoStrapi.vue?vue&type=script&lang=js&"
import style0 from "./VideoStrapi.vue?vue&type=style&index=0&id=6774d4bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6774d4bb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/home/northbankcm/public_html/frontend/components/modules/Video.vue').default})
